import Swal from 'sweetalert2';

/**
 * SweetAlert2 preconfigurado con la identidad visual UGM
 * Colores: #252C5F (azul oscuro), #61B7E4 (azul claro)
 */
const UGMSwal = Swal.mixin({
    confirmButtonColor: '#252C5F',
    cancelButtonColor: '#6c757d',
    background: '#fff',
    customClass: {
        popup: 'ugm-swal-popup',
        confirmButton: 'ugm-swal-confirm',
        cancelButton: 'ugm-swal-cancel',
        denyButton: 'ugm-swal-deny',
    },
    didOpen: (popup) => {
        const title = popup.querySelector('.swal2-title');
        if (title) {
            title.style.color = '#252C5F';
            title.style.fontWeight = '700';
            title.style.fontSize = '1.1rem';
        }
        // Icono warning → azul UGM en lugar del naranja por defecto
        const icon = popup.querySelector('.swal2-warning');
        if (icon) {
            icon.style.borderColor = '#252C5F';
            icon.style.color = '#252C5F';
        }
        // Icono error → rojo más suave
        const iconError = popup.querySelector('.swal2-error');
        if (iconError) {
            iconError.style.borderColor = '#dc3545';
            iconError.style.color = '#dc3545';
        }
        // Botones: borde redondeado y font consistente
        popup.querySelectorAll('.swal2-confirm, .swal2-cancel, .swal2-deny').forEach(btn => {
            btn.style.borderRadius = '6px';
            btn.style.fontWeight = '600';
            btn.style.fontSize = '0.875rem';
            btn.style.padding = '8px 20px';
        });
    }
});

export default UGMSwal;
